import AdsPages from "./Ads";
import { AuthPage } from "./Auth/AuthPage";
import ForumsPages from "./Forums";
import LogsPages from "./Log";
import MetricsPages from "./Metrics";
import ModeratorsPages from "./Moderators";
import SectionsPages from "./Sections";
import UsersPages from "./Users";
import NotificationsPages from "./Notifications";
import HelpPages from "./Help";
import ScoringPage from "./Scoring";

const pages = {
  ...AdsPages,
  AuthPage,
  ...ForumsPages,
  ...LogsPages,
  ...MetricsPages,
  ...ModeratorsPages,
  ...SectionsPages,
  ...UsersPages,
  ...NotificationsPages,
  ...HelpPages,
  ...ScoringPage,
};

export default pages;
